import React from "react";
import { PolicyLayout } from "./Delivery";
import { siteConfig } from "../Datas/productData";
import "../css/terms.scss";

function Terms() {
  return (
    <PolicyLayout
      eyebrow="Legal"
      title="Terms & conditions"
      intro={`These terms describe use of the ${siteConfig.brandName} demonstration storefront and its simulated shopping flow.`}
    >
      <p className="policy-page__updated">Last updated: August 15, 2026</p>
      <section>
        <span>01</span>
        <div>
          <h2>Store use</h2>
          <p>You may use this site for lawful personal shopping and product research. Do not interfere with its operation, attempt unauthorized access or use its content to mislead others.</p>
        </div>
      </section>
      <section>
        <span>02</span>
        <div>
          <h2>Products and pricing</h2>
          <p>We aim to present product descriptions, colors, measurements and prices accurately. Screens render color differently, and minor variation is natural in denim, leather and garment-dyed goods.</p>
          <p>This project is a frontend demonstration: checkout does not create a real commercial order or process funds.</p>
        </div>
      </section>
      <section>
        <span>03</span>
        <div>
          <h2>Orders</h2>
          <p>In a production store, an order would remain subject to stock, payment authorization and acceptance. Obvious pricing or inventory errors may be corrected before dispatch.</p>
        </div>
      </section>
      <section>
        <span>04</span>
        <div>
          <h2>Intellectual property</h2>
          <p>Site code, copy, graphics and original generated photography are provided for this project. They may not be presented as another retailer’s endorsement or used to imitate a third party’s protected brand assets.</p>
        </div>
      </section>
      <section>
        <span>05</span>
        <div>
          <h2>Questions</h2>
          <p>For questions about these terms, contact <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.</p>
        </div>
      </section>
    </PolicyLayout>
  );
}

export default Terms;
